import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Button } from "react-aria-components";
import { XClose } from "../icons/solid.js";
import { Avatar } from "./Avatar.js";
import { badge, badgeText, closeButton, icon } from "./Badge.css.js";
import { BadgeContext } from "./BadgeContext.js";
import { Dot } from "./Dot.js";
import { Tooltip, TooltipIcon } from "./Tooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BadgeSizeToTooltipSizeMap = {
  s: "xs",
  m: "s",
  l: "m"
};
const BadgeSizeToAvatarSizeMap = {
  m: "xxs",
  l: "xs"
};
const BaseBadge = (props, ref) => {
  const $ = _c(41);
  const {
    inGroup,
    badgeBorders
  } = React.useContext(BadgeContext);
  const {
    size: t0,
    color: t1,
    outline: t2,
    children
  } = props;
  const size = t0 === undefined ? "m" : t0;
  const color = t1 === undefined ? "primary" : t1;
  const outline = t2 === undefined ? false : t2;
  const {
    variant: t3
  } = props;
  const variant = t3 === undefined ? "default" : t3;
  const t4 = variant === "iconOnly";
  let t5;
  if ($[0] !== badgeBorders || $[1] !== color || $[2] !== inGroup || $[3] !== outline || $[4] !== size || $[5] !== t4) {
    t5 = badge({
      size,
      color,
      outline,
      iconOnly: t4,
      inGroup,
      badgeBorders
    });
    $[0] = badgeBorders;
    $[1] = color;
    $[2] = inGroup;
    $[3] = outline;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const wrapperClassName = t5;
  if (props.variant === "iconOnly") {
    const {
      leadingIcon: Icon
    } = props;
    let t6;
    if ($[7] !== Icon) {
      t6 = /*#__PURE__*/_jsx(Icon, {
        className: icon
      });
      $[7] = Icon;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== ref || $[10] !== t6 || $[11] !== wrapperClassName) {
      t7 = /*#__PURE__*/_jsx("span", {
        ref: ref,
        role: "presentation",
        className: wrapperClassName,
        children: t6
      });
      $[9] = ref;
      $[10] = t6;
      $[11] = wrapperClassName;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  let t6;
  if ($[13] !== props) {
    t6 = iconsForVariant(props);
    $[13] = props;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon
  } = t6;
  let t7;
  if ($[15] !== props.imageSrc || $[16] !== props.name || $[17] !== props.variant || $[18] !== size) {
    t7 = props.variant === "profile" && /*#__PURE__*/_jsx(Avatar, {
      tooltip: false,
      src: props.imageSrc,
      size: BadgeSizeToAvatarSizeMap[size],
      name: props.name,
      showBorder: false
    });
    $[15] = props.imageSrc;
    $[16] = props.name;
    $[17] = props.variant;
    $[18] = size;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== size) {
    t8 = badgeText({
      size
    });
    $[20] = size;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== children || $[23] !== t8) {
    t9 = /*#__PURE__*/_jsx("span", {
      className: t8,
      children: children
    });
    $[22] = children;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== props.onClose || $[26] !== variant) {
    t10 = (variant === "close" || variant === "profile") && props.onClose != null && /*#__PURE__*/_jsx(Button, {
      className: closeButton,
      onPress: props.onClose,
      slot: "remove",
      children: /*#__PURE__*/_jsx(XClose, {
        className: icon
      })
    });
    $[25] = props.onClose;
    $[26] = variant;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== color || $[29] !== props.tooltipText || $[30] !== size) {
    t11 = props.tooltipText != null && /*#__PURE__*/_jsx(Tooltip, {
      text: props.tooltipText,
      children: /*#__PURE__*/_jsx(TooltipIcon, {
        color: color === "white" ? "gray" : color,
        size: BadgeSizeToTooltipSizeMap[size]
      })
    });
    $[28] = color;
    $[29] = props.tooltipText;
    $[30] = size;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== LeadingIcon || $[33] !== TrailingIcon || $[34] !== ref || $[35] !== t10 || $[36] !== t11 || $[37] !== t7 || $[38] !== t9 || $[39] !== wrapperClassName) {
    t12 = /*#__PURE__*/_jsxs("span", {
      ref: ref,
      role: "presentation",
      className: wrapperClassName,
      children: [t7, LeadingIcon, t9, TrailingIcon, t10, t11]
    });
    $[32] = LeadingIcon;
    $[33] = TrailingIcon;
    $[34] = ref;
    $[35] = t10;
    $[36] = t11;
    $[37] = t7;
    $[38] = t9;
    $[39] = wrapperClassName;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
};
const colorToDotColorMap = {
  white: "lightGray",
  gray: "gray",
  primary: "primary",
  error: "red",
  warning: "yellow",
  success: "green",
  blue: "blue"
};
const colorToDotSizeMap = {
  s: "s",
  m: "m",
  l: "m"
};
function iconsForVariant(props) {
  const {
    leadingIcon: LeadingIcon,
    trailingIcon: TrailingIcon,
    color,
    size
  } = props;
  switch (props.variant) {
    case "iconOnly":
      {
        return {
          leadingIcon: LeadingIcon ? /*#__PURE__*/_jsx(LeadingIcon, {
            className: icon
          }) : undefined
        };
      }
    case "dot":
      {
        return {
          leadingIcon: /*#__PURE__*/_jsx(Dot, {
            color: props.dotColor ?? (color == null ? "primary" : colorToDotColorMap[color]),
            size: props.dotSize ?? (size == null ? "m" : colorToDotSizeMap[size])
          })
        };
      }
    case "close":
      {
        return {};
      }
    default:
      {
        return {
          leadingIcon: LeadingIcon ? /*#__PURE__*/_jsx(LeadingIcon, {
            className: icon
          }) : undefined,
          trailingIcon: TrailingIcon ? /*#__PURE__*/_jsx(TrailingIcon, {
            className: icon
          }) : undefined
        };
      }
  }
}
export const Badge = /*#__PURE__*/React.forwardRef(BaseBadge);
//# sourceMappingURL=Badge.js.map